import FilterBadges from './filterBadges';
import BadgeItemView from './filterBadgeHeader';

export default FilterBadges.extend({
  className: 'filter-row',

  itemView: BadgeItemView,

  collectionEvents: {
    refresh: 'render'
  },

  initialize(...args) {
    FilterBadges.prototype.initialize.apply(this, args);

    this.collection = this.filters;
  }
});
